// extracted by mini-css-extract-plugin
module.exports = {"mobileBreakPoint":"425px","screenWidthMobile":"375px","screenWidthDesktop":"1308px","Menu":"menu_Menu__3O0T5","Menu__header":"menu_Menu__header__1BVyi"};